import { render, staticRenderFns } from "./configurePoster.vue?vue&type=template&id=6b028d7d"
import script from "./configurePoster.vue?vue&type=script&lang=js"
export * from "./configurePoster.vue?vue&type=script&lang=js"
import style0 from "./configurePoster.vue?vue&type=style&index=0&id=6b028d7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports